import React from "react";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);


const DoughnutChart = ({labels, values, label}) => {

    const data = {
        labels: labels,
        datasets: [
            {
                label: label,
                data: values,
                backgroundColor: [
                        'rgba(120, 113, 188, 1)',
                        'rgba(120, 113, 188, .5)',
                        'rgba(120, 113, 188, .25)',
                        'rgba(120, 113, 188, .12)',
                ],
                borderColor: [
                    'rgba(255, 255, 255, 1)',
                ],
                borderWidth: 4,
            },
        ],
    };

    return (
        <Doughnut data={data}  type="doughnut" />
    )

}

export default DoughnutChart;
